// extracted by mini-css-extract-plugin
export default {"bread":"Breadcrumbs_bread__auYuN","root":"Breadcrumbs_root__vVByp"};